<script lang='ts'>
  import * as _ from 'lodash';
  import ProductCards from './ProductCards.svelte';
  import { tick } from 'svelte';
  import Sortable from 'sortablejs';
  import type { Storefront, StorefrontCollection } from 'app/javascript/shared/javascripts/types/Storefront';
  export let storefront : Storefront;
  export let callbacks: any;

  let sortObj: any;
  let sortOrder:StorefrontCollection[];

  function saveSort(sortOrder : StorefrontCollection[]) {
    let storefront2 = {id:storefront.id, storefront_collections_attributes: sortOrder}
    callbacks.update(storefront2);
  }

  function doSort() {
    sortOrder = [];
    let nodes = document.getElementById('collections-to-sort').childNodes;
    if (!((nodes || []).length > 0)) { return }

    let position : number = 0;
    nodes.forEach(function(l) {
      if (!(l instanceof HTMLElement)) {
        // fixes type issue
        return;
      }

      if (_.get(l, 'dataset.key') && l.dataset.key != 'undefined') {
        sortOrder.push({id: parseInt(l.dataset.key), position: position})
        position += 1;
      }
    });
    saveSort(sortOrder);
  }

  async function initSort() {
    await tick()
    var el = document.getElementById('collections-to-sort');
    if (el) {
      sortObj = Sortable.create(el,
        {
          onSort: function() {
            doSort()
          },
          handle: '.collection-grab-handle'
        }
      );
      return sortObj;
    }
  }

  $: initSort();

  $: {
    storefront = storefront;
  }
</script>

<span id='collections-to-sort'>
  {#each storefront.storefront_collections_attributes as collection (collection)}
    <ProductCards {storefront} {callbacks} {collection}></ProductCards>
  {/each}
</span>

